import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { TeamIdPayload } from 'Interfaces/Team';
import { $actions } from 'Store/ducks';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((payload: TeamIdPayload) =>
    $actions.team.acceptInvite(dispatch, payload),
  );
};
